import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b556b2ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tree-item q-tree__node relative-position" }
const _hoisted_2 = ["draggable", "data-id", "data-type"]
const _hoisted_3 = {
  key: 1,
  class: "tree-item__icons"
}
const _hoisted_4 = { class: "tree-item__text" }
const _hoisted_5 = {
  key: 0,
  class: "q-tree__children"
}


import Node from '@/Tree/Node';
import { TreeItem } from '@/Tree/types';
import { computed, PropType, reactive } from 'vue';
import { useTreeStore } from '@/store/tree/treeModule';
import { actionHandler } from '@/actions/actionHandler';
import { PasteDirection, IDropParams } from '~store/tree/types';
import { usePatientsStore } from '@/store/patients/patientsModule';

const __default__ = { name: 'TreeItemComponent' };

type PasteDirectionMap = {
  [key: string]: -1 | 0 | 1;
};

const pasteDirectionMap: PasteDirectionMap = {
  over: -1,
  under: 1,
  into: 0,
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  item: {
    type: Object as PropType<Node>,
    default: () => {},
  },
  selectedItem: {
    type: String as PropType<string | null>,
    default: () => null,
  },
},
  emits: ['select'],
  setup(__props, { emit }) {

const props = __props




const treeStore = useTreeStore();

const isRoot = computed(() => !data.itemData.id_type);
const isNode = computed(() => data.itemData.id_type === 1);
const isLeaf = computed(() => data.itemData.id_type === 2);

const isSelected = computed(() => data.itemData.id_tree === props.selectedItem);

const data = reactive({
  isLoading: false,
  isSelected: false,
  itemData: props.item.data as TreeItem,
  expanded: false,
  isDragging: false,
  isHovered: false,
  pasteDirection: null as PasteDirection | null,
});



const toggle = async () => {
  if (data.expanded) {
    data.expanded = false;
    return;
  }
  if (props.item.children.length) {
    data.expanded = true;
    return;
  }
  data.isLoading = true;
  await treeStore.loadTreeNode(data.itemData.id_tree);
  data.isLoading = false;
  data.expanded = true;
};

const translateEmit = (id: string) => {
  emit('select', id);
};

const select = async (type_drop: 0 | 1) => {
  const params = {
    id_tree: data.itemData.id_tree,
    type: data.itemData.id_type,
    type_drop,
    delayed: true,
  };
  if (!isLeaf.value && type_drop === 1) {
    emit('select', params);
    await usePatientsStore().getTableData('GET:tree_staff_list', { ...params }, 1);
    usePatientsStore().setTableMode(1);
    return;
  }
  emit('select', params);
};

const showHazardsModal = () => {
  actionHandler({
    name: 'HazardsModal',
    type: 'modal',
    customParam: data.itemData,
  });
};

const onDragStart = (ev: DragEvent) => {
  if (ev.dataTransfer && ev.target) {
    data.expanded = false;
    const { dataset } = ev.target as HTMLElement;
    if (dataset.id) ev.dataTransfer.setData('itemID', dataset.id);
  }
};

const defineDirection = (target: HTMLElement, position: number): void => {
  const range = {
    top: target.getBoundingClientRect().top,
    bottom: target.getBoundingClientRect().bottom,
  };
  if (isRoot.value) {
    data.pasteDirection = 'into';
    return;
  }
  const halfHeight = (range.bottom - range.top) / 3;
  if (position < range.top + halfHeight) {
    data.pasteDirection = 'over';
    return;
  }
  if (position > range.bottom - halfHeight) {
    data.pasteDirection = 'under';
    return;
  }
  data.pasteDirection = 'into';
};

const onDragOver = (ev: DragEvent) => {
  if (isLeaf.value) {
    return;
  }
  if (ev.dataTransfer && ev.target) {
    let target = ev.target as HTMLElement;
    if (!target.classList.contains('tree-item__content')) {
      const path = ev.composedPath() as HTMLElement[];
      target = path.find((item) => item.classList.contains('tree-item__content')) as HTMLElement;
    }
    const { dataset } = target;
    if (dataset.id) {
      defineDirection(target, ev.clientY);
    }
  }
};

const onDragLeave = () => {
  data.isHovered = false;
  data.pasteDirection = null;
};

const onDrop = async (ev: DragEvent) => {
  if (isLeaf.value) {
    return;
  }
  data.isLoading = true;
  if (ev.dataTransfer && ev.target) {
    const sourceId = ev.dataTransfer.getData('itemID');
    const type_drop = data.pasteDirection ? pasteDirectionMap[data.pasteDirection] : 0;
    if (sourceId === data.itemData.id_tree) {
      return;
    }
    const params: IDropParams = {
      id_tree_drag: sourceId,
      id_tree_drop: data.itemData.id_tree,
      type_drop,
    };
    data.pasteDirection = null;
    await treeStore.moveTreeItem(params);
  }
  data.isLoading = false;
};


return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_spinner_ios = _resolveComponent("q-spinner-ios")!
  const _component_q_chip = _resolveComponent("q-chip")!
  const _component_TreeItemComponent = _resolveComponent("TreeItemComponent")!
  const _component_q_slide_transition = _resolveComponent("q-slide-transition")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(['q-tree__node-header', 'relative-position', { root: _unref(isRoot) }])
    }, [
      (_unref(isNode) && data.itemData.has_children)
        ? (_openBlock(), _createBlock(_component_q_icon, {
            key: 0,
            class: _normalizeClass(['q-tree__arrow', {'q-tree__arrow--rotate': data.expanded}]),
            name: "arrow_right",
            size: "sm",
            onClick: toggle
          }, null, 8, ["class"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass([
          'tree-item__content',
          { 'tree-item__content_selected': _unref(isSelected) },
          `paste_${data.pasteDirection}`,
        ]),
        draggable: !_unref(isRoot),
        "data-id": data.itemData.id_tree,
        "data-type": data.itemData.id_type,
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (select(0)), ["stop"])),
        onDblclick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (select(1)), ["stop"])),
        onDragstart: _cache[2] || (_cache[2] = ($event: any) => (onDragStart($event), data.isDragging = true)),
        onDragend: _cache[3] || (_cache[3] = ($event: any) => (data.isDragging = false)),
        onDragover: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (onDragOver($event), data.isHovered = true), ["prevent"])),
        onDragenter: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"])),
        onDragleave: onDragLeave,
        onDrop: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (onDrop($event), data.isHovered = false), ["stop","prevent"]))
      }, [
        _createVNode(_component_q_icon, {
          name: "east",
          size: "md",
          class: "paste__icon"
        }),
        (data.isLoading)
          ? (_openBlock(), _createBlock(_component_q_spinner_ios, {
              key: 0,
              color: "primary",
              size: "2em"
            }))
          : (_openBlock(), _createElementBlock("span", _hoisted_3, [
              (_unref(isRoot))
                ? (_openBlock(), _createBlock(_component_q_icon, {
                    key: 0,
                    name: "home",
                    size: "sm"
                  }))
                : _createCommentVNode("", true),
              (_unref(isNode))
                ? (_openBlock(), _createBlock(_component_q_icon, {
                    key: 1,
                    name: "business",
                    size: "sm"
                  }))
                : _createCommentVNode("", true),
              (_unref(isLeaf))
                ? (_openBlock(), _createBlock(_component_q_chip, {
                    key: 2,
                    color: "primary",
                    "text-color": "white",
                    icon: "people"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(data.itemData.people_amount), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_unref(isLeaf))
                ? (_openBlock(), _createBlock(_component_q_chip, {
                    key: 3,
                    clickable: "",
                    color: "accent",
                    "text-color": "white",
                    icon: "notification_important",
                    onClick: showHazardsModal
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(data.itemData.cnt_hazard), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])),
        _createElementVNode("span", _hoisted_4, _toDisplayString(__props.item.data.title), 1)
      ], 42, _hoisted_2)
    ], 2),
    _createVNode(_component_q_slide_transition, null, {
      default: _withCtx(() => [
        (_unref(isRoot) || (__props.item.children.length && data.expanded))
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.item.children, (child) => {
                return (_openBlock(), _createBlock(_component_TreeItemComponent, {
                  key: child.data.id_tree,
                  item: child,
                  selectedItem: __props.selectedItem,
                  onSelect: translateEmit
                }, null, 8, ["item", "selectedItem"]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})